/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceReference } from './SourceReference';
import {
    SourceReferenceFromJSON,
    SourceReferenceFromJSONTyped,
    SourceReferenceToJSON,
    SourceReferenceToJSONTyped,
} from './SourceReference';
import type { FieldProvenance } from './FieldProvenance';
import {
    FieldProvenanceFromJSON,
    FieldProvenanceFromJSONTyped,
    FieldProvenanceToJSON,
    FieldProvenanceToJSONTyped,
} from './FieldProvenance';

/**
 * 
 * @export
 * @interface VulnerabilityDefinitionEntity
 */
export interface VulnerabilityDefinitionEntity {
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    cveId?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    cweId?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    vulnerabilityId?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    vulnerabilityType?: VulnerabilityDefinitionEntityVulnerabilityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    severity?: VulnerabilityDefinitionEntitySeverityEnum;
    /**
     * 
     * @type {number}
     * @memberof VulnerabilityDefinitionEntity
     */
    cvssScore?: number;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    cvssVector?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    cvssVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    cvssSource?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VulnerabilityDefinitionEntity
     */
    kevListed?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityDefinitionEntity
     */
    kevDueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    nvdStatus?: VulnerabilityDefinitionEntityNvdStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof VulnerabilityDefinitionEntity
     */
    epssScore?: number;
    /**
     * 
     * @type {number}
     * @memberof VulnerabilityDefinitionEntity
     */
    epssPercentile?: number;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityDefinitionEntity
     */
    publishedDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityDefinitionEntity
     */
    modifiedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    vendor?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    product?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    productVersion?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VulnerabilityDefinitionEntity
     */
    affectedVersions?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof VulnerabilityDefinitionEntity
     */
    exploitAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    exploitMaturity?: VulnerabilityDefinitionEntityExploitMaturityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof VulnerabilityDefinitionEntity
     */
    patchAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    remediation?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    workaround?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {Array<SourceReference>}
     * @memberof VulnerabilityDefinitionEntity
     */
    sourceReferences?: Array<SourceReference>;
    /**
     * 
     * @type {{ [key: string]: FieldProvenance; }}
     * @memberof VulnerabilityDefinitionEntity
     */
    fieldProvenance?: { [key: string]: FieldProvenance; };
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityDefinitionEntity
     */
    lastSyncedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityDefinitionEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityDefinitionEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityDefinitionEntity
     */
    updatedBy?: string;
}


/**
 * @export
 */
export const VulnerabilityDefinitionEntityVulnerabilityTypeEnum = {
    Cve: 'CVE',
    Stig: 'STIG',
    Custom: 'CUSTOM',
    VendorAdvisory: 'VENDOR_ADVISORY',
    Cwe: 'CWE'
} as const;
export type VulnerabilityDefinitionEntityVulnerabilityTypeEnum = typeof VulnerabilityDefinitionEntityVulnerabilityTypeEnum[keyof typeof VulnerabilityDefinitionEntityVulnerabilityTypeEnum];

/**
 * @export
 */
export const VulnerabilityDefinitionEntitySeverityEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Info: 'INFO'
} as const;
export type VulnerabilityDefinitionEntitySeverityEnum = typeof VulnerabilityDefinitionEntitySeverityEnum[keyof typeof VulnerabilityDefinitionEntitySeverityEnum];

/**
 * @export
 */
export const VulnerabilityDefinitionEntityNvdStatusEnum = {
    Analyzed: 'ANALYZED',
    AwaitingAnalysis: 'AWAITING_ANALYSIS',
    UndergoingAnalysis: 'UNDERGOING_ANALYSIS',
    Rejected: 'REJECTED',
    Disputed: 'DISPUTED'
} as const;
export type VulnerabilityDefinitionEntityNvdStatusEnum = typeof VulnerabilityDefinitionEntityNvdStatusEnum[keyof typeof VulnerabilityDefinitionEntityNvdStatusEnum];

/**
 * @export
 */
export const VulnerabilityDefinitionEntityExploitMaturityEnum = {
    Unproven: 'UNPROVEN',
    ProofOfConcept: 'PROOF_OF_CONCEPT',
    Functional: 'FUNCTIONAL',
    High: 'HIGH'
} as const;
export type VulnerabilityDefinitionEntityExploitMaturityEnum = typeof VulnerabilityDefinitionEntityExploitMaturityEnum[keyof typeof VulnerabilityDefinitionEntityExploitMaturityEnum];


/**
 * Check if a given object implements the VulnerabilityDefinitionEntity interface.
 */
export function instanceOfVulnerabilityDefinitionEntity(value: object): value is VulnerabilityDefinitionEntity {
    return true;
}

export function VulnerabilityDefinitionEntityFromJSON(json: any): VulnerabilityDefinitionEntity {
    return VulnerabilityDefinitionEntityFromJSONTyped(json, false);
}

export function VulnerabilityDefinitionEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): VulnerabilityDefinitionEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'cveId': json['cveId'] == null ? undefined : json['cveId'],
        'cweId': json['cweId'] == null ? undefined : json['cweId'],
        'vulnerabilityId': json['vulnerabilityId'] == null ? undefined : json['vulnerabilityId'],
        'vulnerabilityType': json['vulnerabilityType'] == null ? undefined : json['vulnerabilityType'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'cvssScore': json['cvssScore'] == null ? undefined : json['cvssScore'],
        'cvssVector': json['cvssVector'] == null ? undefined : json['cvssVector'],
        'cvssVersion': json['cvssVersion'] == null ? undefined : json['cvssVersion'],
        'cvssSource': json['cvssSource'] == null ? undefined : json['cvssSource'],
        'kevListed': json['kevListed'] == null ? undefined : json['kevListed'],
        'kevDueDate': json['kevDueDate'] == null ? undefined : (new Date(json['kevDueDate'])),
        'nvdStatus': json['nvdStatus'] == null ? undefined : json['nvdStatus'],
        'epssScore': json['epssScore'] == null ? undefined : json['epssScore'],
        'epssPercentile': json['epssPercentile'] == null ? undefined : json['epssPercentile'],
        'publishedDate': json['publishedDate'] == null ? undefined : (new Date(json['publishedDate'])),
        'modifiedDate': json['modifiedDate'] == null ? undefined : (new Date(json['modifiedDate'])),
        'vendor': json['vendor'] == null ? undefined : json['vendor'],
        'product': json['product'] == null ? undefined : json['product'],
        'productVersion': json['productVersion'] == null ? undefined : json['productVersion'],
        'affectedVersions': json['affectedVersions'] == null ? undefined : json['affectedVersions'],
        'exploitAvailable': json['exploitAvailable'] == null ? undefined : json['exploitAvailable'],
        'exploitMaturity': json['exploitMaturity'] == null ? undefined : json['exploitMaturity'],
        'patchAvailable': json['patchAvailable'] == null ? undefined : json['patchAvailable'],
        'remediation': json['remediation'] == null ? undefined : json['remediation'],
        'workaround': json['workaround'] == null ? undefined : json['workaround'],
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'sourceReferences': json['sourceReferences'] == null ? undefined : ((json['sourceReferences'] as Array<any>).map(SourceReferenceFromJSON)),
        'fieldProvenance': json['fieldProvenance'] == null ? undefined : (mapValues(json['fieldProvenance'], FieldProvenanceFromJSON)),
        'lastSyncedAt': json['lastSyncedAt'] == null ? undefined : (new Date(json['lastSyncedAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
    };
}

export function VulnerabilityDefinitionEntityToJSON(json: any): VulnerabilityDefinitionEntity {
    return VulnerabilityDefinitionEntityToJSONTyped(json, false);
}

export function VulnerabilityDefinitionEntityToJSONTyped(value?: VulnerabilityDefinitionEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'cveId': value['cveId'],
        'cweId': value['cweId'],
        'vulnerabilityId': value['vulnerabilityId'],
        'vulnerabilityType': value['vulnerabilityType'],
        'title': value['title'],
        'description': value['description'],
        'severity': value['severity'],
        'cvssScore': value['cvssScore'],
        'cvssVector': value['cvssVector'],
        'cvssVersion': value['cvssVersion'],
        'cvssSource': value['cvssSource'],
        'kevListed': value['kevListed'],
        'kevDueDate': value['kevDueDate'] == null ? undefined : ((value['kevDueDate']).toISOString().substring(0,10)),
        'nvdStatus': value['nvdStatus'],
        'epssScore': value['epssScore'],
        'epssPercentile': value['epssPercentile'],
        'publishedDate': value['publishedDate'] == null ? undefined : ((value['publishedDate']).toISOString()),
        'modifiedDate': value['modifiedDate'] == null ? undefined : ((value['modifiedDate']).toISOString()),
        'vendor': value['vendor'],
        'product': value['product'],
        'productVersion': value['productVersion'],
        'affectedVersions': value['affectedVersions'],
        'exploitAvailable': value['exploitAvailable'],
        'exploitMaturity': value['exploitMaturity'],
        'patchAvailable': value['patchAvailable'],
        'remediation': value['remediation'],
        'workaround': value['workaround'],
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'sourceReferences': value['sourceReferences'] == null ? undefined : ((value['sourceReferences'] as Array<any>).map(SourceReferenceToJSON)),
        'fieldProvenance': value['fieldProvenance'] == null ? undefined : (mapValues(value['fieldProvenance'], FieldProvenanceToJSON)),
        'lastSyncedAt': value['lastSyncedAt'] == null ? undefined : ((value['lastSyncedAt']).toISOString()),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
    };
}

